<div class="header">
    <img src="../../../assets/logo-site.png" alt="Logo" class="logo">
    <span class="header-text">Olá {{aluno}}</span>
    <button mat-button class="menu-button" (click)="isDesktop = !isDesktop">
        <mat-icon>menu</mat-icon>
    </button>
</div>

<div id="body" class="container">

    <div class="sidebar" *ngIf="isDesktop">
        <ul>

            <li *ngFor="let item of menuItems">
                <div (click)="linkSeletor(item.url,item.id)"
                    style="display: flex; justify-content: space-between; cursor: pointer;">
                    <img [src]="item.image" alt="{{ item.text }}">
                    <span>{{ item.text }}</span>
                </div>
            </li>
        </ul>
    </div>

    <div id='card' class="card-container">
        <div class="row" style="width: -webkit-fill-available;">
            <div class="card col-md-4" *ngFor="let card of videoItems">
                <img [src]="'../../../assets/' + removerAcentos(card.image) + '.png'" alt="{{ card.text }}"
                    (click)="carregaThumb(card.id)" style="cursor: pointer;">
            </div>
        </div>
    </div>

    <div id="nBotoes" class="navBotao ">
        <mat-icon [disabled]="isFirstPage" (click)="previousPage()"
            style="margin-right: 10px; cursor: pointer;">arrow_back_ios</mat-icon>
        <mat-icon [disabled]="isLastPage" (click)="nextPage()" style="cursor: pointer;">arrow_forward_ios</mat-icon>
    </div>


    <div id="thumb" class="thumb-container">
        <div class="row">
            <div class="card col-md-4" *ngFor="let card of getItems()">
                <img style="z-index: 0;" [src]="card.thumbnail.high.url" alt="{{ card.text }}"
                    (click)="carregaVideo(card.videoId)" style="cursor: pointer;">
                <div class="indicador">
                    {{card.title}}<br>
                </div>
            </div>
        </div>
    </div>

    <img id="divBackButton" src="../../../assets/back-white.png" (click)="retornaButton()">
    <div id="divVideo" class="vYoutube">
        <img id="divBackThumb" src="../../../assets/back-white.png" (click)="retornaThumb()">
        <div #videoContainer id="videoContainer" class="frame"></div>
        <!-- <div id="loading-message">Aguarde um instante, o vídeo está sendo carregado...</div> -->
    </div>

</div>